FontAwesomeConfig = { replacementClass: "fa" };
